import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterInitialsComponent } from './table-filter-initials.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  declarations: [TableFilterInitialsComponent],
  exports: [TableFilterInitialsComponent],
})

export class TableFilterInitialsModule {
}
